import IdleTimeHandler from './idle-time-handler'
import { useIdleTimeHandler } from './utils'

export { useIdleTimeHandler }
export default IdleTimeHandler
